export interface ClientQuote {
  quote: string;
  brand: string;
  logo?: string;
}

export const CLIENT_QUOTES: ClientQuote[] = [
  {
    quote:
      "LSEG has greatly benefited from Global Database's API for KYB checks, providing us with quick and reliable business verifications essential for our operations.",
    brand: 'LSEG',
    logo: 'img/customers/lseg.svg',
  },
  {
    quote:
      "Global Database's business credit reports are a cornerstone of Kroll's risk management. Their detailed insights help us accurately assess credit risks, ensuring informed decisions.",
    brand: 'Kroll',
    logo: 'img/customers/kroll.svg',
  },
  {
    quote:
      'HSBC relies on Global Database for comprehensive business credit reports. Their precise data is vital to our credit risk assessments, aiding in our decision-making processes.',
    brand: 'HSBC',
    logo: 'img/customers/hsbc.svg',
  },
];
